import { Injectable } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { ConfirmGoalDeleteComponent, ConfirmGoalDeleteModalData } from "../components/confirm-goal-delete/confirm-goal-delete.component";

type ConfirmGoalDeleteArgs = {
  linkedMetrics?: { name: string }[];
  action(): void | Promise<unknown>;
};

@Injectable()
export class ConfirmGoalDeleteService {
  constructor(private modalService: UiModalService) {}

  public confirmGoalDelete(args: ConfirmGoalDeleteArgs): void {
    this.modalService.confirm<ConfirmGoalDeleteComponent, ConfirmGoalDeleteModalData>({
      uiTitle: localize("delete_x", { data: localize("objective") }),
      uiContent: ConfirmGoalDeleteComponent,
      uiIconType: null,
      uiData: {
        linkedMetrics: args.linkedMetrics || [],
      },
      uiOkText: localize("delete"),
      uiOkDanger: true,
      uiOnOk: () => args.action(),
      uiCancelText: localize("cancel"),
    });
  }
}
